export default __webpack_public_path__ + "static/media/bulb.36ea56df.png";